import _ from 'lodash'
import React from 'react'
import { useTheme } from 'react-jss'
import useReactFontLoader from 'react-font-loader'
import FooterCheckout from '../footer-checkout'
import HeaderCheckout from '../header-checkout'
import useStyles from './layout-checkout-style'
import PaymentLogos from '../payment-logos'

const LayoutCheckoutView = ({
  children,
  disableFooter,
  disablePaymentFooter,
}) => {
  const styles = useStyles()
  const theme = useTheme()
  const extraScripts = _.get(theme, 'config.pages.layout.extraScripts', [{}])
  useReactFontLoader({
    url: _.get(theme, 'typo.fontFamilyUrl'),
  })
  return (
    <div className={styles.containerFluid}>
      <HeaderCheckout
        className={styles.header}
      />
      <div className={styles.container}>{children}</div>
      { !disablePaymentFooter && <PaymentLogos /> }
      { !disableFooter && <FooterCheckout useSuspense={false} /> }
      {!_.isEmpty(extraScripts)
        && _.map(extraScripts, (script, idx) => <script key={idx} type={script.type}>{`${script.code}`}</script>)}
    </div>
  )
}

export default LayoutCheckoutView
